'use client'

import { Fragment, useEffect, useState } from 'react'

import { OFFICE_HOURS } from '@/lib/office'

/** Row of `OFFICE_HOURS` (Monday first) for each `Intl` short weekday. */
const WEEKDAY_INDEX: Record<string, number> = {
  Mon: 0,
  Tue: 1,
  Wed: 2,
  Thu: 3,
  Fri: 4,
  Sat: 5,
  Sun: 6,
}

/** Today's row in Warsaw time, whatever zone the visitor's device is in. */
function todayIndex(): number {
  const name = new Intl.DateTimeFormat('en-US', {
    weekday: 'short',
    timeZone: 'Europe/Warsaw',
  }).format(new Date())
  return WEEKDAY_INDEX[name] ?? -1
}

/**
 * The office week, one row per day, today marked with a „dziś" tag — the
 * comp's footer table (`.fh-ft-hours`).
 *
 * Client-side because "today" is a fact about the moment the page is read and
 * the footer is prerendered. Until mount nothing is marked, so the server pass
 * and the first client frame agree.
 */
export function OfficeWeek() {
  const [today, setToday] = useState(-1)
  useEffect(() => setToday(todayIndex()), [])

  return (
    <dl className="fh-ft-hours">
      {OFFICE_HOURS.map(({ day, open }, index) => {
        const mark = index === today ? 'fh-today' : undefined
        return (
          <Fragment key={day}>
            <dt className={mark}>{day.toLowerCase()}</dt>
            <dd className={mark}>{open ?? 'zamknięte'}</dd>
          </Fragment>
        )
      })}
    </dl>
  )
}
